import React from "react";
import netflix from "../assets/portfolio/netflix.png";
import lucan from "../assets/portfolio/lucan.png";
import lemonade from "../assets/portfolio/lemonade.png";
import python_project from "../assets/portfolio/python_project.jpg";
import astronova from "../assets/portfolio/astronova.png";
import movievilla from "../assets/portfolio/movievilla.png";



const Portfolio = () => {
  const portfolios = [
    {
      id: 1,
      src: lucan,
      alt: "LUCAN",
      href: "https://perks.lucan.io/"
    },
    {
      id: 2,
      src: netflix,
      alt: "Netflix Clone",
      href: "https://github.com/MohitVerma007/Netflix-clone"
    },
    {
      id: 3,
      src: lemonade,
      alt: "Lemonade",
      href: "https://lemonade.careers/"
    },
    {
      id: 4,
      src: python_project,
      alt: "Face Attendance System",
      href: "https://github.com/MohitVerma007/Face_Detection_Attendence_System"
    },
    {
      id: 5,
      src: astronova,
      alt: "Astronova",
      href: "https://github.com/MohitVerma007/astronova_backend"
    },
    {
      id: 6,
      src: movievilla,
      alt:"MovieVilla",
      href: "https://github.com/MohitVerma007/MovieVilla-React/tree/main"
    },
  ];

  return (
    <div
      name="portfolio"
      className="bg-gradient-to-b from-black to-gray-800 w-full md:h-screen text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Portfolio
          </p>
          <p className="py-6">Please check out my portfolio showcasing the projects I've developed using the MERN stack, which demonstrates my skills in web development. In addition to MERN projects, I have also created projects on nocode platforms like Bubble and some using Python.</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {portfolios.map(({ id, src,alt,href }) => (
            <div key={id} className=" shadow-md shadow-gray-600 rounded-lg">
              <img
                src={src}
                alt=""
                className="rounded-md duration-200 hover:scale-105"
              />

              <div className="flex items-center justify-center">
              <a href={href} target="_blank" rel="noreferrer">
                <button className="  px-6 py-3 m-4 duration-200 hover:scale-105">
                  {alt} 
                </button>
              </a>
                {/* <button className="px-6 py-3 w-1/2 m-4 duration-200 hover:scale-105">
                  Code
                </button> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
